
import Vue from 'vue';
import Component from 'vue-class-component';
import HelpdeskNav from '@/components/helpdesk/HelpdeskNav.vue';

// Parent route of every helpdesk page: the top nav stays put while the child view changes.
@Component({ name: 'HelpdeskLayout', components: { HelpdeskNav } })
export default class HelpdeskLayout extends Vue {}
